import FetchHelper from '../helpers/fetch_helper';

const DisbursementDispatcher = {
  async fetchDisbursements() {
    try {
      return await FetchHelper.fetchJson(encodeURI('disbursements'), {
        method: 'GET',
        version: '/v3',
      });
    } catch (error) {
      this.dispatch({
        type: 'handleRequestError',
        data: { error, defaultErrorMessage: 'Could not retrieve Disbursements' },
      });
      return null;
    }
  },

  async fetchCancelledDisbursements() {
    try {
      return await FetchHelper.fetchJson(encodeURI('cancelled-disbursements'), {
        method: 'GET',
        version: '/v3',
      });
    } catch (error) {
      this.dispatch({
        type: 'handleRequestError',
        data: { error, defaultErrorMessage: 'Could not retrieve Cancelled Disbursements' },
      });
      return null;
    }
  },

  async fetchMilestoneDisbursements() {
    try {
      return await FetchHelper.fetchJson(encodeURI('milestone-disbursements'), {
        method: 'GET',
        version: '/v3',
      });
    } catch (error) {
      this.dispatch({
        type: 'handleRequestError',
        data: { error, defaultErrorMessage: 'Could not retrieve Milestone Disbursements' },
      });
      return null;
    }
  },
};

export default DisbursementDispatcher;
